import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./index.css";
import "@fontsource/raleway/400.css";
import "@fontsource/raleway/500.css";
import "@fontsource/raleway/600.css";
import "@fontsource/raleway/700.css";
import "@fontsource/raleway/800.css";
import "@fontsource/noto-sans/400.css";
import "@fontsource/noto-sans/600.css";
import "@fontsource/noto-sans-malayalam/400.css";
import "@fontsource/noto-sans-malayalam/600.css";
import { STORAGE_KEYS } from "./const";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

Sentry.init({
  dsn: "https://FSFtXKJMTQZfe7aZwqypzAjc@s2791044.us-west-2a.betterstackdata.com/2791044",
  environment: process.env.NODE_ENV || "development",
});

const shopId = localStorage.getItem(STORAGE_KEYS.SHOP_ID);
const shopName = localStorage.getItem(STORAGE_KEYS.SHOP_NAME);
if (shopId || shopName) {
  Sentry.setUser({
    id: shopId || undefined,
    username: shopName || undefined,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
